import { ErrorMessage, Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

const TicketManuallyInput = ({
  codeFromUrl,
  isFetching,
  onSubmit,
  scanWithCamera,
}) => {
  const validationSchema = Yup.object().shape({
    ticketCode: Yup.string()
      .matches(/^\d{8}$/, 'Ticket code must be exactly 8 digits')
      .required('Ticket code is required'),
  });

  const handleSubmit = (values) => {
    onSubmit(values.ticketCode);
  };

  const initialValues = { ticketCode: codeFromUrl || '' };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnMount
    >
      {({ isValid, values }) => {
        const isInitiallyValid = validationSchema.isValidSync(initialValues);
        const hasChanged = values.ticketCode !== initialValues.ticketCode;
        const shouldEnableSubmit =
          (isValid && hasChanged) || (isInitiallyValid && !hasChanged);

        return (
          <Form className="space-y-4">
            <h4 className="text-black">Enter your ticket code</h4>
            <Field
              name="ticketCode"
              className="form-control"
              type="text"
              inputMode="numeric"
              placeholder="Enter ticket code"
            />
            <ErrorMessage
              name="ticketCode"
              component="div"
              className="text-danger text-x-small mt-1"
            />
            <div className="d-grid gap-2">
              <button
                type="submit"
                className="btn btn-primary w-100 text-white"
                disabled={isFetching || !shouldEnableSubmit}
              >
                Submit
              </button>
              <button
                type="button"
                className="btn btn-link button-link text-small"
                onClick={scanWithCamera}
              >
                Scan with camera
              </button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default TicketManuallyInput;
TicketManuallyInput.propTypes = {
  codeFromUrl: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  scanWithCamera: PropTypes.func.isRequired,
};
